/**
 * Assinatura no terminal — docs/09-POS-PROPOSTA.md §5.2 e risco R1.
 *
 * Cada terminal tem o seu par de chaves RSA 2048, gerado na activação e
 * guardado no cofre do sistema (Android Keystore / Windows DPAPI). A chave
 * privada nunca sai do dispositivo; a pública é certificada pela chave do
 * produtor (servidor) com `deviceCertificateString`. O algoritmo é o mesmo
 * do Makila (RSASSA-PKCS1-v1_5 / SHA-256, base64), por isso `verify` e
 * `verifyChain` de @makila/fiscal/signature verificam documentos do POS sem
 * mudança — só com a chave pública do terminal.
 */
const RSA_PARAMS = { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-256' };
/** Signer sobre WebCrypto (WebView Android, Tauri, Node 24). */
export function webCryptoSigner(keyId, privateKey) {
    return {
        keyId,
        async sign(canonical) {
            const sig = await globalThis.crypto.subtle.sign(RSA_PARAMS, privateKey, new TextEncoder().encode(canonical));
            return toBase64(new Uint8Array(sig));
        },
    };
}
/**
 * Gera o par de chaves do terminal. A privada é não-exportável; a pública sai
 * em SPKI/PEM para o pedido de activação.
 */
export async function generateTerminalKeyPair() {
    const pair = await globalThis.crypto.subtle.generateKey({ ...RSA_PARAMS, modulusLength: 2048, publicExponent: new Uint8Array([1, 0, 1]) }, false, ['sign', 'verify']);
    const spki = new Uint8Array(await globalThis.crypto.subtle.exportKey('spki', pair.publicKey));
    return { privateKey: pair.privateKey, publicKeyPem: toPem(spki, 'PUBLIC KEY') };
}
export { deviceCertificateString } from '@makila/fiscal';
function toBase64(bytes) {
    let bin = '';
    for (const b of bytes)
        bin += String.fromCharCode(b);
    return btoa(bin);
}
function toPem(der, label) {
    const b64 = toBase64(der).replace(/(.{64})/g, '$1\n').trimEnd();
    return `-----BEGIN ${label}-----\n${b64}\n-----END ${label}-----\n`;
}
//# sourceMappingURL=signer.js.map